'use client'

import React from 'react';
import useInView from '../../../../lib/hooks/useInView';
import styles from './CenteredPicturePhraseText.module.css';
import { useAOS } from '@/src/lib/hooks/useAOS';

interface CenteredPicturePhraseTextProps {
  imageUrl: string;
  imageHeight?: string;
  imageWidth?: string;
  phrase: string;
  details: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const CenteredPicturePhraseText: React.FC<CenteredPicturePhraseTextProps> = ({
  imageUrl,
  imageHeight = '800px',
  imageWidth = '480px',
  phrase,
  details,
  buttonText = 'En savoir plus',
  onButtonClick,
}) => {
  const [ref, isInView] = useInView({
    threshold: 0.1,
    rootMargin: '0px 0px -35% 0px', // Trigger earlier only here
  });
  useAOS();


  return (
    <section className={styles.wrapper} ref={ref}>
      <div className={styles.inner} style={{ height: imageHeight, width: imageWidth }}>
        <h2 className={`${styles.phrase} ${isInView ? styles.animatePhrase : ''}`} data-aos='fade-down'>
          {phrase}
        </h2>
        <img
          src={imageUrl}
          alt="Sportif en action"
          className={`${styles.image} ${isInView ? styles.animateImage : ''}`}
          loading="lazy"
          data-aos='fade-up'
        />
        <div className={`${styles.detailsBox} ${isInView ? styles.animateDetails : ''}`} data-aos='zoom-in' data-aos-delay='100'>
          <p className={styles.detailsText}>{details}</p>
          {onButtonClick && (
            <button className={styles.button} onClick={onButtonClick}>
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default CenteredPicturePhraseText;
